import {CircleIcon, PersonIcon} from '@primer/octicons-react'
import {AvatarStack} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'
import {graphql, usePaginationFragment} from 'react-relay'

import type {Assignees$key} from './__generated__/Assignees.graphql'
import {Assignee} from './Assignee'
import styles from './Assignees.module.css'

type assigneesProps = {
  assigneeskey: Assignees$key
  /**
   * Href getter for the assignee badge links
   * @param name - name of the assignee
   * @returns URL to the assignee
   */
  getAssigneeHref: (assignee: string) => string
  showPlaceholder?: boolean
}

export function Assignees({assigneeskey, getAssigneeHref, showPlaceholder = true}: assigneesProps) {
  const {data} = usePaginationFragment(
    graphql`
      fragment Assignees on Assignable
      @argumentDefinitions(assigneePageSize: {type: "Int"}, cursor: {type: "String"})
      @refetchable(queryName: "IssueAssigneePaginatedQuery") {
        assignedActors(first: $assigneePageSize, after: $cursor) @connection(key: "IssueAssignees_assignedActors") {
          edges {
            node {
              ... on User {
                id
              }
              ... on Bot {
                id
              }
              ...Assignee @dangerously_unaliased_fixme
            }
          }
        }
      }
    `,
    assigneeskey,
  )
  const assignees = (data.assignedActors?.edges || []).flatMap(a => (a && a.node ? a.node : []))

  if (!assignees.length) {
    if (!showPlaceholder) {
      return null
    }

    return (
      <div className={styles.noAssigneeContainer}>
        <Octicon icon={PersonIcon} className={styles.noAssigneePersonIcon} />
        <Octicon size={24} icon={CircleIcon} className={styles.noAssigneeBackgroundIcon} />
      </div>
    )
  }

  return (
    <AvatarStack alignRight className={styles.AssigneesAvatarStack}>
      {assignees.map(assignee => (
        <Assignee key={assignee.id} assignee={assignee} getAssigneeHref={getAssigneeHref} />
      ))}
    </AvatarStack>
  )
}

try{ Assignees.displayName ||= 'Assignees' } catch {}